module.exports = __webpack_public_path__ + "static/media/headshot_andrew.cac35532.png";